<template>
<div class="slds-var-p-around_small slds-grid slds-grid_align-center" v-if="$auth.isAuthenticated">
	<div class="slds-col slds-size_6-of-6">
	<article class="slds-card slds-m-top_large">
		<div class="slds-card__header slds-grid">
			<header class="slds-media slds-media_center slds-has-flexi-truncate">
				<div class="slds-media__body">
					<h2 class="slds-card__header-title">
						<span>Campaign Attributes</span>
					</h2>
				</div>
			</header>
		</div>
		<div class="slds-card__body slds-card__body_inner">
			<div class="slds-form" role="list">
				<div class="slds-form__row">
					<div class="slds-form__item" role="listitem">
						<fieldset class="slds-form-element slds-form-element_compound">
							<div class="slds-form-element__control">
								<div class="slds-form-element__row">
								<div class="slds-size_1-of-2">
									<div class="slds-form-element">
										<label class="slds-form-element__label slds-no-flex" for="appealStartDate">Campaign Start Date</label>
										<div class="slds-form-element__control slds-input-has-icon">
											<input class="slds-input" type="date" v-model="startDateSelected" @change="setFilter($event)" name="APPEALSTARTDATE" id="appealStartDate">
										</div>
									</div>
								</div>
								<div class="slds-size_1-of-2">
									<div class="slds-form-element">
										<label class="slds-form-element__label slds-no-flex" for="appealEndDate">Campaign End Date</label>
										<div class="slds-form-element__control slds-input-has-icon">
											<input class="slds-input" type="date" v-model="endDateSelected" @change="setFilter($event)" name="APPEALENDDATE" id="appealEndDate">
										</div>
									</div>
								</div>
								</div>
							</div>
						</fieldset>
					</div>
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="appealMonth">Campaign Month</label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="appealMonthSelected" name="APPEAL_MONTH" id="appealMonth">
										<option v-for="month in appealMonths" v-bind:key="month.lookUpValueCode" 
											v-bind:value="month.lookUpValueText">{{month.lookUpValueDesc}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="slds-form__row">
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="appealIdFrom">Campaign Names</label>
							<div class="slds-form-element__control">
								<textarea class="slds-textarea" id="campaignIds" v-model="campaignIds" @change="setFilter($event)" rows="6" cols="50" name="CAMPAIGNIDS"></textarea>
							</div>
						</div>
					</div>
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="appealIdLike">Campaign ID Like</label>
							<div class="slds-form-element__control">
								<input class="slds-input" type="text" v-model="appealIdLikeSelected" @change="setFilter($event)" name="APPEALIDLIKE" id="appealIdLike">
							</div>	
						</div>
					</div>
				</div>
				<div class="slds-form__row">
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="carrierpostagetype">Carrier Postage Type </label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="carrierPostageTypeSelected" name="POSTAGE_TYPE" id="carrierpostagetype">
										<option v-for="carrierPostage in carrierPostageType" v-bind:key="carrierPostage.lookUpValueCode" 
											v-bind:value="carrierPostage.lookUpValueText">{{carrierPostage.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="carriersize">Carrier Size</label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="carrierSizeSelected" name="CARRIER_SIZE" id="carriersize">
										<option v-for="carrierSize in carrierSizes" v-bind:key="carrierSize.lookUpValueCode" 
										v-bind:value="carrierSize.lookUpValueText">{{carrierSize.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="slds-form__row">
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="replypostagetype">Reply Postage Type </label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="replyPostageTypeSelected" name="REPLY_POSTAGE_TYPE" id="replypostagetype">
										<option v-for="replyPostageType in replyPostageTypes" v-bind:key="replyPostageType.lookUpValueCode" 
										v-bind:value="replyPostageType.lookUpValueText">{{replyPostageType.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="doublesidedprinting">Double Sided Printing</label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="doubleSidedPrintingSelected" name="DOUBLESIDEDPRINTING" id="doublesidedprinting">
										<option v-for="doubleSidedPrinting in doubleSidedPrintings" v-bind:key="doubleSidedPrinting.lookUpValueCode" 
										v-bind:value="doubleSidedPrinting.lookUpValueText">{{doubleSidedPrinting.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="slds-form__row">
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="signer">Signer </label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="signerSeleted" name="SIGNER" id="signer" >
										<option v-for="signer in signers" v-bind:key="signer.lookUpValueCode" 
										v-bind:value="signer.lookUpValueText">{{signer.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="channel">Channel</label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="channelSelected" name="CHANNEL" id="channel">
										<option v-for="channel in channels" v-bind:key="channel.lookUpValueCode" 
										v-bind:value="channel.lookUpValueText">{{channel.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="slds-form__row">
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="purpose">Purpose</label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="purposeSelected" id="purpose" name="PURPOSE">
										<option v-for="purpose in purposes" v-bind:key="purpose.lookUpValueCode" 
										v-bind:value="purpose.lookUpValueText">{{purpose.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="detaiChannel">Detail Channel</label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="detailChannelSelected" id="detaiChannel" name="DETAIL_CHANNEL">
										<option v-for="detailChannel in detailChannels" v-bind:key="detailChannel.lookUpValueCode" 
										v-bind:value="detailChannel.lookUpValueText">{{detailChannel.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</article>
	
	<article class="slds-card">
		<div class="slds-card__header slds-grid">
			<header class="slds-media slds-media_center slds-has-flexi-truncate">
				<div class="slds-media__body">
					<h2 class="slds-card__header-title">
						<span>Account Attributes</span>
					</h2>
				</div>
			</header>
		</div>
		<div class="slds-card__body slds-card__body_inner">
			<div class="slds-form" role="list">
				<div class="slds-form__row">
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="giftChannel">First Gift Channel</label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="giftChannelSelected" id="giftChannel" name="GIFT_CHANNEL">
										<option v-for="giftChannel in giftChannels" v-bind:key="giftChannel.lookUpValueCode" 
										v-bind:value="giftChannel.lookUpValueText">{{giftChannel.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="firstGiftDetailChannel">First Gift Detail Channel</label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="firstGiftDetailChannelSelected" id="firstGiftDetailChannel" name="FIRST_GIFT_DETAIL_CHANNEL">
										<option v-for="detailChannel in firstGiftDetailChannels" v-bind:key="detailChannel.lookUpValueCode" 
										v-bind:value="detailChannel.lookUpValueText">{{detailChannel.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="slds-form" role="list">
				<div class="slds-form__row">
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element slds-form-element_stacked">
							<label class="slds-form-element__label slds-no-flex" for="firstGiftSigner">First Gift Signer</label>
							<div class="slds-form-element__control">
								<div class="slds-select_container">
									<select class="slds-select" @change="setFilter($event)" v-model="firstGiftSignerSeleted" name="FIRST_GIFT_SIGNER" id="firstGiftSigner" >
										<option v-for="signer in firstGiftSigners" v-bind:key="signer.lookUpValueCode" 
										v-bind:value="signer.lookUpValueText">{{signer.lookUpValueText}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="slds-form__item" role="listitem">
						<fieldset class="slds-form-element slds-form-element_compound">
							<legend class="slds-form-element__legend slds-form-element__label"># of gifts in previous 12 months</legend>
							<div class="slds-form-element__control">
								<div class="slds-form-element__row">
								<div class="slds-size_1-of-2">
									<div class="slds-form-element">		
										<div class="slds-form-element__control slds-input-has-fixed-addon">
											<span class="slds-form-element__addon" id="fixed-text-addon-pre">&gt;=</span>
											<input class="slds-input" v-model="numGiftGreaterSelected" type="Number" min="0" step="1" @change="setFilter($event)" name="NUM_GIFTS_GREATER" id="initialGiftSizeGreater">
										</div>
									</div>
								</div>
								<div class="slds-size_1-of-2">
									<div class="slds-form-element">
										<div class="slds-form-element__control slds-input-has-fixed-addon">
											<span class="slds-form-element__addon" id="fixed-text-addon-pre">&lt;=</span>
											<input class="slds-input" v-model="numGiftLessSelected" type="Number" min="0" step="1" @change="setFilter($event)" name="NUM_GIFTS_LESS" id="initialGiftSizeLess">
										</div>
									</div>
								</div>
								</div>
							</div>
						</fieldset>
					</div>
				</div>
			</div>
		</div>
	</article>

	<article class="slds-card">
		<div class="slds-card__header slds-grid">
			<header class="slds-media slds-media_center slds-has-flexi-truncate">
				<div class="slds-media__body">
					<h2 class="slds-card__header-title">
						<span>Options</span>
					</h2>
				</div>
			</header>
		</div>
		<div class="slds-card__body slds-card__body_inner">
			<div class="slds-form" role="list">
				<div class="slds-form__row">
					<div class="slds-form__item" role="listitem">
						<div class="slds-form-element">
							<label class="slds-checkbox_toggle slds-grid">
								<span class="slds-form-element__label slds-m-bottom_none">Gift Size</span>
								<input type="checkbox" v-model="giftSizeOption" @change="setGiftSizeOption($event)" name="GIFT_SIZE_OPTION" />
								<span id="giftsizeoption" class="slds-checkbox_faux_container" aria-live="assertive">
									<span class="slds-checkbox_faux"></span>
									<span class="slds-checkbox_off">Average</span>
									<span class="slds-checkbox_on">Highest Previous</span>
								</span>
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</article>
	
	<!--Ended-->
	</div>
</div>
	

</template> 
<script>
	import {getLookUpValuesByCodeUrl} from '../config';
	// Import component
    //import Loading from 'vue-loading-overlay';
    // Import stylesheet
	//import 'vue-loading-overlay/dist/vue-loading.css';
	let dateFullYear = new Date().getFullYear();
	let appealStartDate = dateFullYear + '-01-01';
	let appealEndDate = dateFullYear + '-12-31';
	export default {
		name: 'DonorAnalysis',
		data() {
			return {
                carrierPostageType: [],
				carrierPostageTypeSelected: '',
				channels: [],
				channelSelected:'',
				carrierSizes: [],
				carrierSizeSelected: '',
				replyPostageTypes: [],
				replyPostageTypeSelected: '',
				signers:[],
				signerSeleted: '',
				firstGiftSigners: [],
				firstGiftSignerSeleted: '',
				purposes:[],
				appealMonths: [],
				appealMonthSelected: '',
				purposeSelected:'',
				detailChannels:[],
				detailChannelSelected:'',
				types:[],
				typeSelected:'',
				giftChannels:[],
				giftChannelSelected:'',
				selectedFilter:[],
				doubleSidedPrintings:[],
				doubleSidedPrintingSelected:'',
				startDateSelected: appealStartDate,
				endDateSelected: appealEndDate,
				appealIdLikeSelected: '',
				numGiftGreaterSelected: '',
				numGiftLessSelected: '',
				campaignIds:'',
				campIdsArr:{}, 
				firstGiftDetailChannelSelected: '',
				firstGiftDetailChannels: [],
				giftSizeOption: false,
			};
		},
		components: {
            //Loading
        },
		created: function() {
			this.getCarrierPostageTypeList();
			this.getChannel();
			this.getCarrierSize();
			this.getreplyPostageType();
			this.getSigner();
			this.getPurpose();
			this.getDetailChannel();
			this.getType();
			this.getGiftChannel();
			this.getDoubleSidedPrinting();
			this.getAppealMonths();
			this.setDefaultSelection();
			this.setFilter();
		},
        methods: {
			resetFilters: function(){
				this.selectedFilter = [];
				this.$route.params.filter = [];
				this.setDefaultSelection();
				this.setFilter();
			},
			setDefaultSelection: function(){
				this.appealMonthSelected = 
					this.firstGiftDetailChannelSelected =
					this.carrierPostageTypeSelected =
					this.channelSelected =
					this.carrierSizeSelected =
					this.replyPostageTypeSelected =
					this.signerSeleted = 
					this.detailChannelSelected = 
					this.doubleSidedPrintingSelected = 
					this.typeSelected = 
					this.firstGiftSignerSeleted = 
					this.giftChannelSelected = 'All';
				this.purposeSelected = 'Solicitation';
				this.campaignIds = this.appealIdLikeSelected = '';
				this.startDateSelected = appealStartDate;
				this.endDateSelected = appealEndDate;
				this.giftSizeOption = false;
				
			},
			getCarrierPostageTypeList: function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'POSTAGE_TYPE')
				.then((response) => {
					this.carrierPostageType = response.data;
					
                }).catch((error => {
                    console.log(error);            
                }))
			},
			getAppealMonths: function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'APPEAL_MONTH')
				.then((response) => {
					this.appealMonths = response.data;
					
                }).catch((error => {
                    console.log(error);            
                }))
            },
			getChannel: function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'CHANNEL')
				.then((response) => {
					this.channels = response.data;
					
                }).catch((error => {
                    console.log(error);            
                }))
            },
			getCarrierSize: function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'CARRIER_SIZE')
				.then((response) => {
					this.carrierSizes = response.data;
					
                }).catch((error => {
                    console.log(error);            
                }))
            },
			getreplyPostageType: function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'REPLY_POSTAGE_TYPE')
				.then((response) => {
					this.replyPostageTypes = response.data;
					
                }).catch((error => {
                    console.log(error);            
                }))
            },
			getSigner: function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'SIGNER')
				.then((response) => {
					this.signers = this.firstGiftSigners = response.data;
					
                }).catch((error => {
                    console.log(error);            
                }))
            },
			getPurpose: function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'PURPOSE')
				.then((response) => {
					this.purposes = response.data;
					
                }).catch((error => {
                    console.log(error);            
                }))
            },
			getDetailChannel : function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'DETAIL_CHANNEL')
				.then((response) => {
					this.detailChannels = this.firstGiftDetailChannels = response.data;
					
                }).catch((error => {
                    console.log(error);            
                }))
            },
			getType : function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'TYPE')
				.then((response) => {
					this.types = response.data;
					
				}).catch((error => {
                    console.log(error);            
                }))
            },
			getGiftChannel : function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'GIFT_CHANNEL')
				.then((response) => {
					this.giftChannels = response.data;	
				}).catch((error => {
                    console.log(error);            
                }))
            },
			setFilter (event) {
				if(event !== undefined && event.target != undefined) {
					for (var i = this.selectedFilter.length; i--;) {
						if (this.selectedFilter[i].filterTypeCode === event.target.name) {
							this.selectedFilter.splice(i,1);
						}
					}
					
					if(event.target.value.toLowerCase()!='all' && event.target.value.toLowerCase()!='none' && (event.target.value.toLowerCase()!='' && event.target.value.toLowerCase()!=undefined && event.target.value.toLowerCase()!=null)){
						if(event.target.name == 'CAMPAIGNIDS'){
							var campIds =event.target.value.replace(new RegExp('\\r\\n', 'g'), ',');
							var campaignIdsLists = campIds.split(',');
							this.selectedFilter.push({
								filterTypeCode: event.target.name,
								filterTypeArray : campaignIdsLists
							});
						}
						else if(event.target.name == 'GIFT_SIZE_OPTION') {
							this.selectedFilter.push({
								filterTypeCode: event.target.name,
								filterTypeText: event.target.checked ? 'MAX' : 'AVG' 
							});
						} else {
							this.selectedFilter.push({
								filterTypeCode: event.target.name,
								filterTypeText: event.target.value
							});
						}
					}
				}
				
				if(this.selectedFilter.length == 0){
					this.selectedFilter.push({
						filterTypeCode: 'APPEALSTARTDATE',
						filterTypeText: this.startDateSelected
					}, {
						filterTypeCode: 'APPEALENDDATE',
						filterTypeText: this.endDateSelected
					}, {
						filterTypeCode: 'PURPOSE',
						filterTypeText: this.purposeSelected
					},  {
						filterTypeCode: 'GIFT_SIZE_OPTION',
						filterTypeText: this.giftSizeOption ? 'MAX' : 'AVG'
					});
				}
				
			},
			getDoubleSidedPrinting: function () {	
				this.axios.get(getLookUpValuesByCodeUrl + 'DOUBLESIDEDPRINTING')
				.then((response) => {
					this.doubleSidedPrintings = JSON.parse(JSON.stringify(response.data));
                }).catch((error => {
                    console.log(error);            
                }))
            },
			onCancel() {
              console.log('User cancelled the loader.')
			},
			searchDonors(){
				this.$emit('searchData', { filter:this.selectedFilter })
			},
			setCampIds(){
				
			},
			setGiftSizeOption: function (event) {	
				this.giftSizeOption = event.target.checked;
				this.setFilter(event);
            }
		}
    };
</script>
<style scoped>
	textarea {
        resize: none;
	}
	.slds-form-element__legend {
		font-weight: 400;
	}
</style>